// extracted by mini-css-extract-plugin
export default {"mask":"index_mask_dfaAA","video_wp":"index_video_wp_ZYljA","close":"index_close_azf0j"};